import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoBlock } from '../../components/Common/InfoBlock';
import { ReportData } from './types';

type ReportDetailProps = {
  rowData: ReportData;
};

export const ReportAccessDetail: FC<ReportDetailProps> = ({ rowData }) => {
  const [t] = useTranslation('ReportAccess');
  return (
    <div>
      <InfoBlock title={t('teams')} value={rowData.teams} />
    </div>
  );
};
